@if (contentlet$ | async; as contentlet) {
<div class="default-banner-class">
  @if (contentlet.layout; as layout) {
  <div class="banner-wrapper layout-{{ layout }}">
    <div class="banner-wrapper__content--dots">
      @if (layout !== '3') {
      <div [ngClass]="bannerWidth(contentlet)" class="position-relative banner-content overflow-hidden">
        <div [ngClass]="bannerOverlay(contentlet)"></div>
        <img
          [ngClass]="(animationTriggered$ | async) ? contentlet?.imageAnimation : null"
          [src]="getImageSource(contentlet) | async | dotCmsCodecEncode"
        />
        <div class="caption d-flex justify-content-center align-items-center h-100">
          <div class="container">
            <div [class]="getRowCss(layout)">
              <div [class]="getColumnCss(layout)">
                <div [ngClass]="captionBackgroundHide(contentlet, layout)" [class]="getBannerCss(layout)">
                  <custom-dot-cms-banner-link
                    [animationCss]="
                      (animationTriggered$ | async) ? correctAnimationClass(contentlet?.captionAnimation) : null
                    "
                    [contentlet]="contentlet"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      } @else {
      <div
        [ngClass]="bannerWidth(contentlet)"
        class="banner-content position-relative d-md-flex ban-three"
        [style.background-color]="contentlet?.backgroundColor"
      >
        <div class="banner-three-background" [style.background-color]="contentlet?.backgroundColor"></div>
        <div class="banner-three-container col-md-6">
          <div class="ban-three-content-wrapper">
            <div class="banner-three-caption d-flex justify-content-center align-items-center h-100">
              <div [class]="getRowCss(layout)">
                <div [class]="getColumnCss(layout)">
                  <div [class]="getBannerCss(layout)">
                    <custom-dot-cms-banner-link
                      [animationCss]="
                        (animationTriggered$ | async) ? correctAnimationClass(contentlet?.captionAnimation) : null
                      "
                      [contentlet]="contentlet"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ban-three-img-wrapper col-md-6 px-0">
          <img
            [ngClass]="(animationTriggered$ | async) ? contentlet?.imageAnimation : null"
            [src]="getImageSource(contentlet) | async | dotCmsCodecEncode"
          />
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>
}
